import React from 'react';

import imageSkeleton from '@app/images/no-image-available.jpg';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
	skeleton?: string;
}

const ImageWithSkeleton: React.FC<Props> = (props) => {
	const [error, setError] = React.useState<boolean>(false);
	
	const {skeleton = imageSkeleton} = props;

	const handleError = (e) => {
		setError(true);
		props.onError && props.onError(e);
	};
	
	return <img
		{...props}
		src={error ? skeleton : props.src}
		onError={handleError}
	/>;
};

export default ImageWithSkeleton;
